import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { RecruitingHiringCriteriaCategoryFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<RecruitingHiringCriteriaCategoryFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormInput
          formItemClassName="col-span-12"
          label="Hiring Criteria Category (required)"
          {...field}
          disabled={!isEditable}
          autoFocus={autoFocus}
        />
      )}
    />
  );
}
